// // // import React from 'react';

// // // const Hero = () => {
// // //   return (
// // //     <section className="h-screen bg-cover bg-center flex items-center justify-center text-white relative" style={{ backgroundImage: "url('/images/hero.jpg')" }}>
// // //       <div className="absolute inset-0 bg-gradient-to-br from-black/60 to-black/30" />
// // //       <div className="relative z-10 text-center px-4">
// // //         <h1 className="text-5xl md:text-6xl font-extrabold mb-4 drop-shadow-lg">Kolorowe Domki</h1>
// // //         <p className="text-xl md:text-2xl font-light">Idealne miejsce nad morzem dla rodzin z dziećmi</p>
// // //       </div>
// // //     </section>
// // //   );
// // // };

// // // export default Hero;


// // import React, { useState, useEffect } from 'react';

// // const Hero = () => {
// //   const [heroData, setHeroData] = useState({
// //     backgroundImage: "/images/hero.jpg",
// //     title: "Kolorowe Domki",
// //     subtitle: "Idealne miejsce nad morzem dla rodzin z dziećmi",
// //     titleStyle: {
// //       fontSize: "5xl",
// //       fontWeight: "extrabold",
// //       color: "#ffffff"
// //     },
// //     subtitleStyle: {
// //       fontSize: "xl",
// //       fontWeight: "light",
// //       color: "#ffffff"
// //     },
// //     overlay: {
// //       enabled: true,
// //       gradient: "bg-gradient-to-br from-black/60 to-black/30"
// //     },
// //     ctaButton: {
// //       enabled: false,
// //       text: "Rezerwuj teraz",
// //       link: "#rezerwacja",
// //       style: {
// //         backgroundColor: "#f59e0b",
// //         color: "#ffffff",
// //         fontSize: "lg",
// //         padding: "12px 24px",
// //         borderRadius: "8px"
// //       }
// //     }
// //   });

// //   useEffect(() => {
// //     const savedData = localStorage.getItem('heroData');
// //     if (savedData) {
// //       setHeroData(JSON.parse(savedData));
// //     }
// //   }, []);

// //   // Funkcja do konwersji stylów na klasy Tailwind
// //   const getTailwindClasses = (style, type) => {
// //     const classes = [];
    
// //     if (type === 'title') {
// //       classes.push(`text-${style.fontSize}`);
// //       classes.push(`font-${style.fontWeight}`);
// //     } else if (type === 'subtitle') {
// //       classes.push(`text-${style.fontSize}`);
// //       classes.push(`font-${style.fontWeight}`);
// //     }
    
// //     return classes.join(' ');
// //   };

// //   return (
// //     <section 
// //       className="h-screen bg-cover bg-center flex items-center justify-center text-white relative" 
// //       style={{ backgroundImage: `url('${heroData.backgroundImage}')` }}
// //     >
// //       {heroData.overlay.enabled && (
// //         <div className={`absolute inset-0 ${heroData.overlay.gradient}`} />
// //       )}
// //       <div className="relative z-10 text-center px-4">
// //         <h1 
// //           className={`${getTailwindClasses(heroData.titleStyle, 'title')} mb-4 drop-shadow-lg`}
// //           style={{ color: heroData.titleStyle.color }}
// //         >
// //           {heroData.title}
// //         </h1>
// //         <p 
// //           className={`${getTailwindClasses(heroData.subtitleStyle, 'subtitle')} drop-shadow-lg`}
// //           style={{ color: heroData.subtitleStyle.color }}
// //         >
// //           {heroData.subtitle}
// //         </p>
        
// //         {heroData.ctaButton.enabled && (
// //           <div className="mt-6">
// //             <a
// //               href={heroData.ctaButton.link}
// //               className="inline-block font-medium transition-colors hover:opacity-90"
// //               style={heroData.ctaButton.style}
// //             >
// //               {heroData.ctaButton.text}
// //             </a>
// //           </div>
// //         )}
// //       </div>
// //     </section>
// //   );
// // };

// // export default Hero;

// // import React, { useState, useEffect } from 'react';

// // const Hero = () => {
// //   const [heroData, setHeroData] = useState({
// //     backgroundImage: "/images/hero.jpg",
// //     title: "Kolorowe Domki",
// //     subtitle: "Idealne miejsce nad morzem dla rodzin z dziećmi",
// //     titleStyle: {
// //       fontSize: "5xl",
// //       fontWeight: "extrabold",
// //       color: "#ffffff"
// //     },
// //     subtitleStyle: {
// //       fontSize: "xl",
// //       fontWeight: "light",
// //       color: "#ffffff"
// //     },
// //     overlay: {
// //       enabled: true,
// //       gradient: "bg-gradient-to-br from-black/60 to-black/30"
// //     }
// //   });

// //   useEffect(() => {
// //     const savedData = localStorage.getItem('heroData');
// //     if (savedData) {
// //       setHeroData(JSON.parse(savedData));
// //     }
// //   }, []);

// //   // Funkcja do konwersji stylów na klasy Tailwind
// //   const getTailwindClasses = (style, type) => {
// //     const classes = [];
    
// //     if (type === 'title') {
// //       classes.push(`text-${style.fontSize}`);
// //       classes.push(`font-${style.fontWeight}`);
// //     } else if (type === 'subtitle') {
// //       classes.push(`text-${style.fontSize}`);
// //       classes.push(`font-${style.fontWeight}`);
// //     }
    
// //     return classes.join(' ');
// //   };

// //   return (
// //     <section 
// //       className="h-screen bg-cover bg-center flex items-center justify-center text-white relative" 
// //       style={{ backgroundImage: `url('${heroData.backgroundImage}')` }}
// //     >
// //       {heroData.overlay.enabled && (
// //         <div className={`absolute inset-0 ${heroData.overlay.gradient}`} />
// //       )}
// //       <div className="relative z-10 text-center px-4">
// //         <h1 
// //           className={`${getTailwindClasses(heroData.titleStyle, 'title')} mb-4 drop-shadow-lg`}
// //           style={{ color: heroData.titleStyle.color }}
// //         >
// //           {heroData.title}
// //         </h1>
// //         <p 
// //           className={`${getTailwindClasses(heroData.subtitleStyle, 'subtitle')} drop-shadow-lg`}
// //           style={{ color: heroData.subtitleStyle.color }}
// //         >
// //           {heroData.subtitle}
// //         </p>
// //       </div>
// //     </section>
// //   );
// // };

// // export default Hero;

// import React, { useState, useEffect } from 'react';

// const Hero = () => {
//   // Array of background images for the slideshow
//   const backgroundImages = [
//     "/images/hero1.jpg",
//     "/images/hero2.jpg",
//     "/images/hero3.jpg",
//     "/images/hero4.jpg",
//     "/images/hero5.jpg"
//   ];

//   const [heroData, setHeroData] = useState({
//     backgroundImage: backgroundImages[0],
//     title: "Kolorowe Domki",
//     subtitle: "Idealne miejsce nad morzem dla rodzin z dziećmi",
//     titleStyle: {
//       fontSize: "5xl",
//       fontWeight: "extrabold",
//       color: "#ffffff"
//     },
//     subtitleStyle: {
//       fontSize: "xl",
//       fontWeight: "light",
//       color: "#ffffff"
//     },
//     overlay: {
//       enabled: true,
//       gradient: "bg-gradient-to-br from-black/60 to-black/30"
//     }
//   });

//   const [currentImageIndex, setCurrentImageIndex] = useState(0);

//   useEffect(() => {
//     const savedData = localStorage.getItem('heroData');
//     if (savedData) {
//       setHeroData(JSON.parse(savedData));
//     }
//   }, []);

//   // Effect for handling the slideshow
//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentImageIndex((prevIndex) => {
//         const nextIndex = (prevIndex + 1) % backgroundImages.length;
//         setHeroData(prevData => ({
//           ...prevData,
//           backgroundImage: backgroundImages[nextIndex]
//         }));
//         return nextIndex;
//       });
//     }, 5000); // Change image every 5 seconds

//     return () => clearInterval(interval); // Cleanup on component unmount
//   }, [backgroundImages.length]);

//   // Funkcja do konwersji stylów na klasy Tailwind
//   const getTailwindClasses = (style, type) => {
//     const classes = [];
    
//     if (type === 'title') {
//       classes.push(`text-${style.fontSize}`);
//       classes.push(`font-${style.fontWeight}`);
//     } else if (type === 'subtitle') {
//       classes.push(`text-${style.fontSize}`);
//       classes.push(`font-${style.fontWeight}`);
//     }
    
//     return classes.join(' ');
//   };

//   return (
//     <section 
//       className="h-screen bg-cover bg-center flex items-center justify-center text-white relative transition-all duration-1000" 
//       style={{ backgroundImage: `url('${heroData.backgroundImage}')` }}
//     >
//       {heroData.overlay.enabled && (
//         <div className={`absolute inset-0 ${heroData.overlay.gradient}`} />
//       )}
//       <div className="relative z-10 text-center px-4">
//         <h1 
//           className={`${getTailwindClasses(heroData.titleStyle, 'title')} mb-4 drop-shadow-lg`}
//           style={{ color: heroData.titleStyle.color }}
//         >
//           {heroData.title}
//         </h1>
//         <p 
//           className={`${getTailwindClasses(heroData.subtitleStyle, 'subtitle')} drop-shadow-lg`}
//           style={{ color: heroData.subtitleStyle.color }}
//         >
//           {heroData.subtitle}
//         </p>
//       </div>
      
//       {/* Optional: Add navigation dots */}
//       <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex space-x-2 z-10">
//         {backgroundImages.map((_, index) => (
//           <div
//             key={index}
//             className={`w-3 h-3 rounded-full ${
//               index === currentImageIndex ? 'bg-white' : 'bg-white/50'
//             }`}
//           />
//         ))}
//       </div>
//     </section>
//   );
// };

// export default Hero;

// import React, { useState, useEffect } from 'react';

// const Hero = () => {
//   // Array of background images for the slideshow
//   const backgroundImages = [
//     "/images/hero1.jpg",
//     "/images/hero2.jpg",
//     "/images/hero3.jpg",
//     "/images/hero4.jpg",
//     "/images/hero5.jpg"
//   ];

//   const [currentImageIndex, setCurrentImageIndex] = useState(0);

//   const [heroData, setHeroData] = useState({
//     title: "Kolorowe Domki",
//     subtitle: "Idealne miejsce nad morzem dla rodzin z dziećmi",
//     titleStyle: {
//       fontSize: "5xl",
//       fontWeight: "extrabold",
//       color: "#ffffff"
//     },
//     subtitleStyle: {
//       fontSize: "xl",
//       fontWeight: "light",
//       color: "#ffffff"
//     },
//     overlay: {
//       enabled: true,
//       gradient: "bg-gradient-to-br from-black/60 to-black/30"
//     }
//   });

//   useEffect(() => {
//     const savedData = localStorage.getItem('heroData');
//     if (savedData) {
//       const parsedData = JSON.parse(savedData);
//       // Zachowujemy wszystkie ustawienia z localStorage OPRÓCZ backgroundImage
//       setHeroData(prevData => ({
//         ...parsedData,
//         // Upewniamy się, że nie nadpisujemy currentImageIndex
//         // backgroundImage jest teraz zarządzany przez currentImageIndex
//       }));
//     }
//   }, []);

//   // Effect for handling the slideshow
//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentImageIndex((prevIndex) => {
//         return (prevIndex + 1) % backgroundImages.length;
//       });
//     }, 5000); // Change image every 5 seconds

//     return () => clearInterval(interval); // Cleanup on component unmount
//   }, [backgroundImages.length]);

//   // Funkcja do konwersji stylów na klasy Tailwind
//   const getTailwindClasses = (style, type) => {
//     const classes = [];
    
//     if (type === 'title') {
//       classes.push(`text-${style.fontSize}`);
//       classes.push(`font-${style.fontWeight}`);
//     } else if (type === 'subtitle') {
//       classes.push(`text-${style.fontSize}`);
//       classes.push(`font-${style.fontWeight}`);
//     }
    
//     return classes.join(' ');
//   };

//   return (
//     <section 
//       className="h-screen bg-cover bg-center flex items-center justify-center text-white relative transition-all duration-1000" 
//       style={{ backgroundImage: `url('${backgroundImages[currentImageIndex]}')` }}
//     >
//       {heroData.overlay.enabled && (
//         <div className={`absolute inset-0 ${heroData.overlay.gradient}`} />
//       )}
//       <div className="relative z-10 text-center px-4">
//         <h1 
//           className={`${getTailwindClasses(heroData.titleStyle, 'title')} mb-4 drop-shadow-lg`}
//           style={{ color: heroData.titleStyle.color }}
//         >
//           {heroData.title}
//         </h1>
//         <p 
//           className={`${getTailwindClasses(heroData.subtitleStyle, 'subtitle')} drop-shadow-lg`}
//           style={{ color: heroData.subtitleStyle.color }}
//         >
//           {heroData.subtitle}
//         </p>
//       </div>
      
//       {/* Optional: Add navigation dots */}
//       <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex space-x-2 z-10">
//         {backgroundImages.map((_, index) => (
//           <div
//             key={index}
//             className={`w-3 h-3 rounded-full ${
//               index === currentImageIndex ? 'bg-white' : 'bg-white/50'
//             }`}
//           />
//         ))}
//       </div>
//     </section>
//   );
// };

// export default Hero;

// import React, { useState, useEffect, useCallback } from 'react';

// const Hero = () => {
//   const backgroundImages = [
//     "/images/hero1.jpg",
//     "/images/hero2.jpg",
//     "/images/hero3.jpg",
//     "/images/hero4.jpg",
//     "/images/hero5.jpg"
//   ];

//   const [currentImageIndex, setCurrentImageIndex] = useState(0);
//   const [imagesPreloaded, setImagesPreloaded] = useState(false);
//   const [currentImageLoaded, setCurrentImageLoaded] = useState(false);

//   const [heroData, setHeroData] = useState({
//     title: "Kolorowe Domki",
//     subtitle: "Idealne miejsce nad morzem dla rodzin z dziećmi",
//     titleStyle: {
//       fontSize: "5xl",
//       fontWeight: "extrabold",
//       color: "#ffffff"
//     },
//     subtitleStyle: {
//       fontSize: "xl",
//       fontWeight: "light",
//       color: "#ffffff"
//     },
//     overlay: {
//       enabled: true,
//       gradient: "bg-gradient-to-br from-black/60 to-black/30"
//     }
//   });

//   // Preload wszystkich obrazów
//   useEffect(() => {
//     const preloadImages = async () => {
//       const promises = backgroundImages.map(src => {
//         return new Promise((resolve, reject) => {
//           const img = new Image();
//           img.src = src;
//           img.onload = resolve;
//           img.onerror = reject;
//         });
//       });

//       try {
//         await Promise.all(promises);
//         setImagesPreloaded(true);
//         setCurrentImageLoaded(true);
//       } catch (error) {
//         console.warn('Some images failed to preload:', error);
//         setImagesPreloaded(true);
//       }
//     };

//     preloadImages();
//   }, []);

//   // Obsługa ładowania bieżącego obrazu
//   useEffect(() => {
//     if (!imagesPreloaded) return;

//     setCurrentImageLoaded(false);
//     const img = new Image();
//     img.src = backgroundImages[currentImageIndex];
//     img.onload = () => setCurrentImageLoaded(true);
//     img.onerror = () => setCurrentImageLoaded(true); // Kontynuuj nawet przy błędzie

//     return () => {
//       img.onload = null;
//       img.onerror = null;
//     };
//   }, [currentImageIndex, imagesPreloaded]);

//   // Pokaz slajdów
//   useEffect(() => {
//     if (!imagesPreloaded) return;

//     const interval = setInterval(() => {
//       setCurrentImageIndex(prev => (prev + 1) % backgroundImages.length);
//     }, 5000);

//     return () => clearInterval(interval);
//   }, [backgroundImages.length, imagesPreloaded]);

//   const getTailwindClasses = (style, type) => {
//     const classes = [];
//     if (type === 'title') {
//       classes.push(`text-${style.fontSize}`);
//       classes.push(`font-${style.fontWeight}`);
//     } else if (type === 'subtitle') {
//       classes.push(`text-${style.fontSize}`);
//       classes.push(`font-${style.fontWeight}`);
//     }
//     return classes.join(' ');
//   };

//   return (
//     <section className="h-screen relative overflow-hidden">
//       {/* Tło z optymalizacjami */}
//       <div 
//         className="absolute inset-0 bg-cover bg-center transition-all duration-1000 ease-in-out"
//         style={{
//           backgroundImage: `url('${backgroundImages[currentImageIndex]}')`,
//           backgroundSize: 'cover',
//           backgroundPosition: 'center',
//           opacity: currentImageLoaded ? 1 : 0,
//           transform: currentImageLoaded ? 'scale(1)' : 'scale(1.02)',
//           filter: currentImageLoaded ? 'blur(0)' : 'blur(4px)',
//           transition: 'opacity 0.8s ease, transform 0.8s ease, filter 0.8s ease'
//         }}
//       />
      
//       {/* Placeholder podczas ładowania */}
//       {!currentImageLoaded && (
//         <div className="absolute inset-0 bg-gray-200 animate-pulse" />
//       )}

//       {heroData.overlay.enabled && (
//         <div className={`absolute inset-0 ${heroData.overlay.gradient}`} />
//       )}
      
//       <div className="relative z-10 text-center px-4 h-full flex flex-col items-center justify-center">
//         <h1 
//           className={`${getTailwindClasses(heroData.titleStyle, 'title')} mb-4 drop-shadow-lg`}
//           style={{ color: heroData.titleStyle.color }}
//         >
//           {heroData.title}
//         </h1>
//         <p 
//           className={`${getTailwindClasses(heroData.subtitleStyle, 'subtitle')} drop-shadow-lg`}
//           style={{ color: heroData.subtitleStyle.color }}
//         >
//           {heroData.subtitle}
//         </p>
//       </div>
      
//       <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex space-x-2 z-10">
//         {backgroundImages.map((_, index) => (
//           <div
//             key={index}
//             className={`w-3 h-3 rounded-full transition-all duration-300 ${
//               index === currentImageIndex ? 'bg-white' : 'bg-white/50'
//             }`}
//           />
//         ))}
//       </div>
//     </section>
//   );
// };

// export default Hero;
// import React, { useState, useEffect } from 'react';
// import { motion, AnimatePresence } from 'framer-motion';

// const Hero = () => {
//   const backgroundImages = [
//     "/images/hero1.jpg",
//     "/images/hero2.jpg",
//     "/images/hero3.jpg",
//     "/images/hero4.jpg",
//     "/images/hero5.jpg"
//   ];

//   const [currentImageIndex, setCurrentImageIndex] = useState(0);
//   const [heroData, setHeroData] = useState({
//     title: "Kolorowe Domki",
//     subtitle: "Idealne miejsce nad morzem dla rodzin z dziećmi",
//     titleStyle: {
//       fontSize: "6xl",
//       fontWeight: "extrabold",
//       color: "#ffffff"
//     },
//     subtitleStyle: {
//       fontSize: "2xl",
//       fontWeight: "light",
//       color: "#ffffff"
//     },
//     overlay: {
//       enabled: true,
//       gradient: "bg-gradient-to-br from-black/40 to-black/20" // Zmniejszona intensywność
//     }
//   });

//   useEffect(() => {
//     const savedData = localStorage.getItem('heroData');
//     if (savedData) {
//       const parsedData = JSON.parse(savedData);
//       setHeroData(prevData => ({
//         ...parsedData,
//       }));
//     }
//   }, []);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentImageIndex((prevIndex) => {
//         return (prevIndex + 1) % backgroundImages.length;
//       });
//     }, 10000);

//     return () => clearInterval(interval);
//   }, [backgroundImages.length]);

//   const getTailwindClasses = (style, type) => {
//     const classes = [];
    
//     if (type === 'title') {
//       classes.push(`text-${style.fontSize}`);
//       classes.push(`font-${style.fontWeight}`);
//     } else if (type === 'subtitle') {
//       classes.push(`text-${style.fontSize}`);
//       classes.push(`font-${style.fontWeight}`);
//     }
    
//     return classes.join(' ');
//   };

//   return (
//     <section className="relative h-screen overflow-hidden">
//       <AnimatePresence mode='wait'>
//         <motion.div
//           key={currentImageIndex}
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           exit={{ opacity: 0 }}
//           transition={{ duration: 1 }}
//           className="absolute inset-0"
//         >
//           <img 
//             src={backgroundImages[currentImageIndex]} 
//             alt={`Hero image ${currentImageIndex + 1}`}
//             className="w-full h-full object-cover"
//           />
          
//           {heroData.overlay.enabled && (
//             <div className={`absolute inset-0 ${heroData.overlay.gradient}`} />
//           )}
          
//           {/* Kontener tekstu z wyższym z-index */}
//           <div className="relative z-20 h-full flex flex-col items-center justify-center text-center px-4">
//             {/* Duży napis "Kolorowe Domki" z mocniejszym cieniem */}
//             <motion.h1 
//               initial={{ y: -50, opacity: 0 }}
//               animate={{ y: 0, opacity: 1 }}
//               transition={{ delay: 0.3, duration: 0.8 }}
//               className="text-6xl md:text-7xl lg:text-8xl font-extrabold mb-4 text-white drop-shadow-2xl leading-tight"
//             >
//               Kolorowe Domki
//             </motion.h1>
            
//             {/* Mniejszy napis podtytułu z mocniejszym cieniem */}
//             <motion.p 
//               initial={{ y: 50, opacity: 0 }}
//               animate={{ y: 0, opacity: 1 }}
//               transition={{ delay: 0.6, duration: 0.8 }}
//               className="text-2xl md:text-3xl lg:text-4xl font-light text-white drop-shadow-2xl max-w-3xl mx-auto leading-relaxed"
//             >
//               Idealne miejsce nad morzem dla rodzin z dziećmi
//             </motion.p>
//           </div>
//         </motion.div>
//       </AnimatePresence>
      
//       {/* Navigation dots */}
//       <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex space-x-2 z-30">
//         {backgroundImages.map((_, index) => (
//           <button
//             key={index}
//             onClick={() => setCurrentImageIndex(index)}
//             className={`w-3 h-3 rounded-full transition-all duration-300 ${
//               index === currentImageIndex ? 'bg-white scale-110' : 'bg-white/50 scale-100'
//             }`}
//             aria-label={`Przejdź do slajdu ${index + 1}`}
//           />
//         ))}
//       </div>
//     </section>
//   );
// };

// export default Hero;



// import React, { useState, useEffect } from 'react';
// import { motion, AnimatePresence } from 'framer-motion';

// const Hero = () => {
//   // Array of background images for the slideshow
//   const backgroundImages = [
//     "/images/hero1.jpg",
//     "/images/hero2.jpg",
//     "/images/hero3.jpg",
//     "/images/hero4.jpg",
//     "/images/hero5.jpg"
//   ];

//   const [currentImageIndex, setCurrentImageIndex] = useState(0);
//   const [heroData, setHeroData] = useState({
//     title: "Kolorowe Domki",
//     subtitle: "Idealne miejsce nad morzem dla rodzin z dziećmi",
//     titleStyle: {
//       fontSize: "5xl",
//       fontWeight: "extrabold",
//       color: "#ffffff"
//     },
//     subtitleStyle: {
//       fontSize: "xl",
//       fontWeight: "light",
//       color: "#ffffff"
//     },
//     overlay: {
//       enabled: true,
//       gradient: "bg-gradient-to-br from-black/60 to-black/30"
//     }
//   });

//   useEffect(() => {
//     const savedData = localStorage.getItem('heroData');
//     if (savedData) {
//       const parsedData = JSON.parse(savedData);
//       setHeroData(prevData => ({
//         ...parsedData,
//       }));
//     }
//   }, []);

//   // Effect for handling the slideshow - 10 sekund jak w Attractions
//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentImageIndex((prevIndex) => {
//         return (prevIndex + 1) % backgroundImages.length;
//       });
//     }, 10000); // Zmiana obrazu co 10 sekund

//     return () => clearInterval(interval);
//   }, [backgroundImages.length]);

//   // Funkcja do konwersji stylów na klasy Tailwind
//   const getTailwindClasses = (style, type) => {
//     const classes = [];
    
//     if (type === 'title') {
//       classes.push(`text-${style.fontSize}`);
//       classes.push(`font-${style.fontWeight}`);
//     } else if (type === 'subtitle') {
//       classes.push(`text-${style.fontSize}`);
//       classes.push(`font-${style.fontWeight}`);
//     }
    
//     return classes.join(' ');
//   };

//   return (
//     <section className="relative h-screen overflow-hidden">
//       <AnimatePresence mode='wait'>
//         <motion.div
//           key={currentImageIndex}
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           exit={{ opacity: 0 }}
//           transition={{ duration: 1 }}
//           className="absolute inset-0"
//         >
//           <img 
//             src={backgroundImages[currentImageIndex]} 
//             alt={`Hero image ${currentImageIndex + 1}`}
//             className="w-full h-full object-cover"
//           />
          
//           {heroData.overlay.enabled && (
//             <div className={`absolute inset-0 ${heroData.overlay.gradient}`} />
//           )}
          
//           <div className="relative z-10 text-center px-4 h-full flex flex-col items-center justify-center">
//             <motion.h1 
//               initial={{ y: -50, opacity: 0 }}
//               animate={{ y: 0, opacity: 1 }}
//               transition={{ delay: 0.3 }}
//               className={`${getTailwindClasses(heroData.titleStyle, 'title')} mb-4 drop-shadow-lg`}
//               style={{ color: heroData.titleStyle.color }}
//             >
//               {heroData.title}
//             </motion.h1>
//             <motion.p 
//               initial={{ y: 50, opacity: 0 }}
//               animate={{ y: 0, opacity: 1 }}
//               transition={{ delay: 0.6 }}
//               className={`${getTailwindClasses(heroData.subtitleStyle, 'subtitle')} drop-shadow-lg`}
//               style={{ color: heroData.subtitleStyle.color }}
//             >
//               {heroData.subtitle}
//             </motion.p>
//           </div>
//         </motion.div>
//       </AnimatePresence>
      
//       {/* Navigation dots */}
//       <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex space-x-2 z-10">
//         {backgroundImages.map((_, index) => (
//           <button
//             key={index}
//             onClick={() => setCurrentImageIndex(index)}
//             className={`w-3 h-3 rounded-full ${index === currentImageIndex ? 'bg-white' : 'bg-white/50'}`}
//             aria-label={`Przejdź do slajdu ${index + 1}`}
//           />
//         ))}
//       </div>
//     </section>
//   );
// };

// export default Hero;


// import React, { useState, useEffect } from 'react';

// const Hero = () => {
//   // Tutaj dodaj ścieżki do swoich 5 obrazów
//   const backgroundImages = [
//     "/images/hero1.jpg",
//     "/images/hero2.jpg",
//     "/images/hero3.jpg",
//     "/images/hero4.jpg",
//     "/images/hero5.jpg"
//   ];

//   const [currentImageIndex, setCurrentImageIndex] = useState(0);
//   const [heroData, setHeroData] = useState({
//     title: "Kolorowe Domki",
//     subtitle: "Idealne miejsce nad morzem dla rodzin z dziećmi",
//     titleStyle: {
//       fontSize: "5xl",
//       fontWeight: "extrabold",
//       color: "#ffffff"
//     },
//     subtitleStyle: {
//       fontSize: "xl",
//       fontWeight: "light",
//       color: "#ffffff"
//     },
//     overlay: {
//       enabled: true,
//       gradient: "bg-gradient-to-br from-black/60 to-black/30"
//     }
//   });

//   useEffect(() => {
//     const savedData = localStorage.getItem('heroData');
//     if (savedData) {
//       setHeroData(JSON.parse(savedData));
//     }
//   }, []);

//   // Efekt do zmiany obrazów co 5 sekund
//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentImageIndex((prevIndex) => 
//         (prevIndex + 1) % backgroundImages.length
//       );
//     }, 5000);

//     return () => clearInterval(interval);
//   }, [backgroundImages.length]);

//   // Funkcja do konwersji stylów na klasy Tailwind
//   const getTailwindClasses = (style, type) => {
//     const classes = [];
    
//     if (type === 'title') {
//       classes.push(`text-${style.fontSize}`);
//       classes.push(`font-${style.fontWeight}`);
//     } else if (type === 'subtitle') {
//       classes.push(`text-${style.fontSize}`);
//       classes.push(`font-${style.fontWeight}`);
//     }
    
//     return classes.join(' ');
//   };

//   return (
//     <section className="h-screen w-full flex items-center justify-center text-white relative overflow-hidden" style={{ margin: 0 }}>
//       {/* Tło z płynnymi przejściami - poprawione aby wyeliminować biały pasek */}
//       <div className="absolute inset-0 transition-opacity duration-1000 ease-in-out" style={{ margin: 0 }}>
//         {backgroundImages.map((image, index) => (
//           <div
//             key={index}
//             className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${index === currentImageIndex ? 'opacity-100' : 'opacity-0'}`}
//             style={{
//               backgroundImage: `url('${image}')`,
//               backgroundSize: 'cover',
//               backgroundPosition: 'center',
//               backgroundRepeat: 'no-repeat',
//               width: '100%',
//               height: '100%',
//               margin: 0,
//               padding: 0
//             }}
//           />
//         ))}
//       </div>
      
//       {heroData.overlay.enabled && (
//         <div className={`absolute inset-0 ${heroData.overlay.gradient}`} style={{ margin: 0 }} />
//       )}
      
//       <div className="relative z-10 text-center px-4" style={{ margin: 0 }}>
//         <h1 
//           className={`${getTailwindClasses(heroData.titleStyle, 'title')} mb-4 drop-shadow-lg`}
//           style={{ color: heroData.titleStyle.color, margin: 0 }}
//         >
//           {heroData.title}
//         </h1>
//         <p 
//           className={`${getTailwindClasses(heroData.subtitleStyle, 'subtitle')} drop-shadow-lg`}
//           style={{ color: heroData.subtitleStyle.color, margin: 0 }}
//         >
//           {heroData.subtitle}
//         </p>
//       </div>
      
//       {/* Pasek postępu */}
//       <div className="absolute bottom-4 left-0 right-0 h-1 bg-white/30 mx-4 z-10" style={{ margin: 0 }}>
//         <div 
//           className="h-full bg-white transition-all duration-5000 ease-linear"
//           style={{ width: '100%' }}
//           key={currentImageIndex}
//         />
//       </div>
      
//       {/* Przyciski nawigacyjne */}
//       <div className="absolute bottom-4 right-4 z-10 flex space-x-2" style={{ margin: 0 }}>
//         {backgroundImages.map((_, index) => (
//           <button
//             key={index}
//             className={`w-3 h-3 rounded-full ${index === currentImageIndex ? 'bg-white' : 'bg-white/50'}`}
//             onClick={() => setCurrentImageIndex(index)}
//             aria-label={`Przejdź do slajdu ${index + 1}`}
//           />
//         ))}
//       </div>
//     </section>
//   );
// };

// export default Hero;

// import React, { useState, useEffect } from 'react';
// import './Hero.css'; // Importujemy plik CSS

// const Hero = () => {
//   const backgroundImages = [
//     "/images/hero1.jpg",
//     "/images/hero2.jpg",
//     "/images/hero3.jpg",
//     "/images/hero4.jpg",
//     "/images/hero5.jpg"
//   ];

//   const [currentImageIndex, setCurrentImageIndex] = useState(0);

//   const [heroData, setHeroData] = useState({
//     title: "Kolorowe Domki",
//     subtitle: "Idealne miejsce nad morzem dla rodzin z dziećmi",
//     titleStyle: {
//       fontSize: "5xl",
//       fontWeight: "extrabold",
//       color: "#ffffff"
//     },
//     subtitleStyle: {
//       fontSize: "xl",
//       fontWeight: "light",
//       color: "#ffffff"
//     },
//     overlay: {
//       enabled: true,
//       gradient: "bg-gradient-to-br from-black/60 to-black/30"
//     }
//   });

//   useEffect(() => {
//     const savedData = localStorage.getItem('heroData');
//     if (savedData) {
//       setHeroData(JSON.parse(savedData));
//     }
//   }, []);

//   // Effect for handling the slideshow
//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentImageIndex((prevIndex) => {
//         return (prevIndex + 1) % backgroundImages.length;
//       });
//     }, 5000); // Change image every 5 seconds

//     return () => clearInterval(interval);
//   }, [backgroundImages.length]);

//   return (
//     <section className="hero-section h-screen flex items-center justify-center text-white relative overflow-hidden">
//       {/* Background images container */}
//       <div className="hero-background">
//         {backgroundImages.map((image, index) => (
//           <div
//             key={index}
//             className={`hero-slide ${index === currentImageIndex ? 'active' : ''}`}
//             style={{ backgroundImage: `url('${image}')` }}
//           />
//         ))}
//       </div>
      
//       {/* Overlay */}
//       {heroData.overlay.enabled && (
//         <div className={`absolute inset-0 ${heroData.overlay.gradient} z-2`} />
//       )}
      
//       {/* Text Container */}
//       <div className="relative z-10 text-center px-4">
//         <h1 className="text-6xl md:text-7xl font-extrabold mb-4 text-white drop-shadow-lg">
//           Kolorowe Domki
//         </h1>
//         <p className="text-2xl md:text-3xl font-light text-white drop-shadow-lg">
//           Idealne miejsce nad morzem dla rodzin z dziećmi
//         </p>
//       </div>
      
//       {/* Navigation dots */}
//       <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex space-x-2 z-10">
//         {backgroundImages.map((_, index) => (
//           <button
//             key={index}
//             onClick={() => setCurrentImageIndex(index)}
//             className={`w-3 h-3 rounded-full transition-all duration-300 ${
//               index === currentImageIndex ? 'bg-white scale-110' : 'bg-white/50 scale-100'
//             }`}
//             aria-label={`Przejdź do slajdu ${index + 1}`}
//           />
//         ))}
//       </div>
//     </section>
//   );
// };

// export default Hero;|

// import React, { useState, useEffect } from 'react';
// import './Hero.css'; // Importujemy plik CSS

// const Hero = () => {
//   const backgroundImages = [
//     "/images/hero1.jpg",
//     "/images/hero2.jpg",
//     "/images/hero3.jpg",
//     "/images/hero4.jpg",
//     "/images/hero5.jpg"
//   ];

//   const [currentImageIndex, setCurrentImageIndex] = useState(0);

//   const [heroData, setHeroData] = useState({
//     title: "Kolorowe Domki",
//     subtitle: "Idealne miejsce nad morzem dla rodzin z dziećmi",
//     overlay: {
//       enabled: true,
//       gradient: "bg-gradient-to-br from-black/60 to-black/30"
//     }
//   });

//   useEffect(() => {
//     const savedData = localStorage.getItem('heroData');
//     if (savedData) {
//       setHeroData(JSON.parse(savedData));
//     }
//   }, []);

//   // Effect for handling the slideshow
//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentImageIndex((prevIndex) => {
//         return (prevIndex + 1) % backgroundImages.length;
//       });
//     }, 5000); // Change image every 5 seconds

//     return () => clearInterval(interval);
//   }, [backgroundImages.length]);

//   return (
//     <section className="hero-section h-screen flex items-center justify-center text-white relative overflow-hidden">
//       {/* Background images container */}
//       <div className="hero-background">
//         {backgroundImages.map((image, index) => (
//           <div
//             key={index}
//             className={`hero-slide ${index === currentImageIndex ? 'active' : ''}`}
//           >
//             {/* Zdjęcie tła */}
//             <div 
//               className="absolute inset-0 bg-cover bg-center"
//               style={{ backgroundImage: `url('${image}')` }}
//             />
            
//             {/* STAŁY OVERLAY NA KAŻDYM ZDJĘCIU */}
//             {heroData.overlay.enabled && (
//               <div className={`absolute inset-0 ${heroData.overlay.gradient}`} />
//             )}
//           </div>
//         ))}
//       </div>
      
//       {/* Text Container */}
//       <div className="relative z-10 text-center px-4">
//         <h1 className="text-6xl md:text-7xl font-extrabold mb-4 text-white drop-shadow-2xl">
//           Kolorowe Domki
//         </h1>
//         <p className="text-2xl md:text-3xl font-light text-white drop-shadow-2xl">
//           Idealne miejsce nad morzem dla rodzin z dziećmi
//         </p>
//       </div>
      
//       {/* Navigation dots */}
//       <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex space-x-2 z-10">
//         {backgroundImages.map((_, index) => (
//           <button
//             key={index}
//             onClick={() => setCurrentImageIndex(index)}
//             className={`w-3 h-3 rounded-full transition-all duration-300 ${
//               index === currentImageIndex ? 'bg-white scale-110' : 'bg-white/50 scale-100'
//             }`}
//             aria-label={`Przejdź do slajdu ${index + 1}`}
//           />
//         ))}
//       </div>
//     </section>
//   );
// };

// export default Hero;

// import React, { useState, useEffect } from 'react';

// const Hero = () => {
//   const API_BASE = 'http://localhost/api';
  
//   const [heroData, setHeroData] = useState({
//     backgroundImages: [
//       "/images/hero1.jpg",
//       "/images/hero2.jpg",
//       "/images/hero3.jpg",
//       "/images/hero4.jpg",
//       "/images/hero5.jpg"
//     ],
//     title: "Kolorowe Domki",
//     subtitle: "Idealne miejsce nad morzem dla rodzin z dziećmi",
//     titleStyle: {
//       fontSize: "6xl",
//       fontWeight: "extrabold",
//       color: "#ffffff"
//     },
//     subtitleStyle: {
//       fontSize: "2xl",
//       fontWeight: "light",
//       color: "#ffffff"
//     },
//     overlay: {
//       enabled: true,
//       gradient: "bg-gradient-to-br from-black/60 to-black/30"
//     },
//     slideshowInterval: 5000
//   });

//   const [currentImageIndex, setCurrentImageIndex] = useState(0);
//   const [loading, setLoading] = useState(true);

//   // Załaduj dane z serwera
//   useEffect(() => {
//     const fetchHeroData = async () => {
//       try {
//         setLoading(true);
//         const response = await fetch(`${API_BASE}/hero.php?t=${Date.now()}`);
        
//         if (!response.ok) {
//           throw new Error('Błąd podczas pobierania danych hero');
//         }
        
//         const data = await response.json();
//         setHeroData(data);
//       } catch (error) {
//         console.error('Błąd ładowania danych hero:', error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchHeroData();

//     // Sprawdzaj zmiany co 10 sekund
//     const interval = setInterval(fetchHeroData, 10000);
//     return () => clearInterval(interval);
//   }, []);

//   // Effect for handling the slideshow
//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentImageIndex((prevIndex) => {
//         return (prevIndex + 1) % heroData.backgroundImages.length;
//       });
//     }, heroData.slideshowInterval);

//     return () => clearInterval(interval);
//   }, [heroData.slideshowInterval, heroData.backgroundImages.length]);

//   if (loading) {
//     return (
//       <section className="h-screen flex items-center justify-center text-white relative overflow-hidden bg-gray-200">
//         <div className="text-center">
//           <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
//           <p className="text-gray-700">Ładowanie...</p>
//         </div>
//       </section>
//     );
//   }

//   return (
//     <section className="hero-section h-screen flex items-center justify-center text-white relative overflow-hidden">
//       {/* Background images container */}
//       <div className="hero-background absolute inset-0">
//         {heroData.backgroundImages.map((image, index) => (
//           <div
//             key={index}
//             className={`absolute inset-0 transition-opacity duration-1000 ${
//               index === currentImageIndex ? 'opacity-100' : 'opacity-0'
//             }`}
//           >
//             {/* Zdjęcie tła */}
//             <div 
//               className="absolute inset-0 bg-cover bg-center"
//               style={{ backgroundImage: `url('${image}')` }}
//             />
            
//             {/* Overlay */}
//             {heroData.overlay.enabled && (
//               <div className={`absolute inset-0 ${heroData.overlay.gradient}`} />
//             )}
//           </div>
//         ))}
//       </div>
      
//       {/* Text Container */}
//       <div className="relative z-10 text-center px-4 max-w-4xl mx-auto">
//         <h1 className={`text-${heroData.titleStyle.fontSize} font-${heroData.titleStyle.fontWeight} mb-4 text-white drop-shadow-2xl`}
//             style={{ color: heroData.titleStyle.color }}>
//           {heroData.title}
//         </h1>
//         <p className={`text-${heroData.subtitleStyle.fontSize} font-${heroData.subtitleStyle.fontWeight} text-white drop-shadow-2xl`}
//            style={{ color: heroData.subtitleStyle.color }}>
//           {heroData.subtitle}
//         </p>
//       </div>
      
//       {/* Navigation dots */}
//       <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex space-x-2 z-10">
//         {heroData.backgroundImages.map((_, index) => (
//           <button
//             key={index}
//             onClick={() => setCurrentImageIndex(index)}
//             className={`w-3 h-3 rounded-full transition-all duration-300 ${
//               index === currentImageIndex ? 'bg-white scale-110' : 'bg-white/50 scale-100'
//             }`}
//             aria-label={`Przejdź do slajdu ${index + 1}`}
//           />
//         ))}
//       </div>
//     </section>
//   );
// };

// export default Hero;


// import React, { useState, useEffect } from 'react';

// const Hero = () => {
//   const API_BASE = '/kolorowedomki/api';
  
//   const [heroData, setHeroData] = useState({
//     backgroundImages: [
//       "/kolorowedomki/images/hero1.jpg",
//       "/kolorowedomki/images/hero2.jpg",
//       "/kolorowedomki/images/hero3.jpg",
//       "/kolorowedomki/images/hero4.jpg",
//       "/kolorowedomki/images/hero5.jpg"
//     ],
//     title: "Kolorowe Domki",
//     subtitle: "Idealne miejsce nad morzem dla rodzin z dziećmi",
//     titleStyle: {
//       fontSize: "6xl",
//       fontWeight: "extrabold",
//       color: "#ffffff"
//     },
//     subtitleStyle: {
//       fontSize: "2xl",
//       fontWeight: "light",
//       color: "#ffffff"
//     },
//     overlay: {
//       enabled: true,
//       gradient: "bg-gradient-to-br from-black/60 to-black/30"
//     },
//     slideshowInterval: 5000
//   });

//   const [currentImageIndex, setCurrentImageIndex] = useState(0);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // Załaduj dane z serwera
//   useEffect(() => {
//     const fetchHeroData = async () => {
//       try {
//         setLoading(true);
//         const response = await fetch(`${API_BASE}/hero.php?t=${Date.now()}`);
        
//         if (!response.ok) {
//           throw new Error('Błąd podczas pobierania danych hero');
//         }
        
//         const data = await response.json();
//         setHeroData(data);
//         setError(null);
//       } catch (error) {
//         console.error('Błąd ładowania danych hero:', error);
//         setError('Nie udało się załadować danych. Używam domyślnych ustawień.');
//         // Używamy domyślnych danych w przypadku błędu
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchHeroData();

//     // Sprawdzaj zmiany co 30 sekund (rzadziej, żeby nie obciążać serwera)
//     const interval = setInterval(fetchHeroData, 30000);
//     return () => clearInterval(interval);
//   }, []);

//   // Effect for handling the slideshow
//   useEffect(() => {
//     if (!heroData.backgroundImages || heroData.backgroundImages.length === 0) {
//       return;
//     }

//     const interval = setInterval(() => {
//       setCurrentImageIndex((prevIndex) => {
//         return (prevIndex + 1) % heroData.backgroundImages.length;
//       });
//     }, heroData.slideshowInterval || 5000);

//     return () => clearInterval(interval);
//   }, [heroData.slideshowInterval, heroData.backgroundImages]);

//   // Funkcja do bezpiecznego pobierania klas Tailwind
//   const getTextSizeClass = (size) => {
//     const sizeMap = {
//       'xl': 'text-xl',
//       '2xl': 'text-2xl',
//       '3xl': 'text-3xl',
//       '4xl': 'text-4xl',
//       '5xl': 'text-5xl',
//       '6xl': 'text-6xl',
//       '7xl': 'text-7xl',
//       '8xl': 'text-8xl'
//     };
//     return sizeMap[size] || 'text-6xl';
//   };

//   const getFontWeightClass = (weight) => {
//     const weightMap = {
//       'light': 'font-light',
//       'normal': 'font-normal',
//       'medium': 'font-medium',
//       'semibold': 'font-semibold',
//       'bold': 'font-bold',
//       'extrabold': 'font-extrabold'
//     };
//     return weightMap[weight] || 'font-bold';
//   };

//   if (loading) {
//     return (
//       <section className="h-screen flex items-center justify-center text-white relative overflow-hidden bg-gray-200">
//         <div className="text-center">
//           <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
//           <p className="text-gray-700">Ładowanie...</p>
//         </div>
//       </section>
//     );
//   }

//   // Bezpieczne pobranie obrazków - jeśli brak, użyj domyślnych
//   const backgroundImages = heroData.backgroundImages && heroData.backgroundImages.length > 0 
//     ? heroData.backgroundImages 
//     : ["/images/hero1.jpg"];

//   return (
//     <section className="hero-section h-screen flex items-center justify-center text-white relative overflow-hidden">
//       {/* Komunikat o błędzie */}
//       {error && (
//         <div className="absolute top-4 left-4 right-4 bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-3 rounded z-50">
//           {error}
//         </div>
//       )}
      
//       {/* Background images container */}
//       <div className="hero-background absolute inset-0">
//         {backgroundImages.map((image, index) => (
//           <div
//             key={index}
//             className={`absolute inset-0 transition-opacity duration-1000 ${
//               index === currentImageIndex ? 'opacity-100' : 'opacity-0'
//             }`}
//           >
//             {/* Zdjęcie tła */}
//             <div 
//               className="absolute inset-0 bg-cover bg-center"
//               style={{ 
//                 backgroundImage: `url('${image}')`,
//                 backgroundPosition: 'center',
//                 backgroundSize: 'cover'
//               }}
//             />
            
//             {/* Overlay */}
//             {heroData.overlay?.enabled && (
//               <div className={`absolute inset-0 ${heroData.overlay.gradient || 'bg-gradient-to-br from-black/60 to-black/30'}`} />
//             )}
//           </div>
//         ))}
//       </div>
      
//       {/* Text Container */}
//       <div className="relative z-10 text-center px-4 max-w-4xl mx-auto">
//         <h1 
//           className={`${getTextSizeClass(heroData.titleStyle?.fontSize)} ${getFontWeightClass(heroData.titleStyle?.fontWeight)} mb-4 drop-shadow-2xl`}
//           style={{ color: heroData.titleStyle?.color || '#ffffff' }}
//         >
//           {heroData.title || "Kolorowe Domki"}
//         </h1>
//         <p 
//           className={`${getTextSizeClass(heroData.subtitleStyle?.fontSize)} ${getFontWeightClass(heroData.subtitleStyle?.fontWeight)} drop-shadow-2xl`}
//           style={{ color: heroData.subtitleStyle?.color || '#ffffff' }}
//         >
//           {heroData.subtitle || "Idealne miejsce nad morzem dla rodzin z dziećmi"}
//         </p>
//       </div>
      
//       {/* Navigation dots */}
//       {backgroundImages.length > 1 && (
//         <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex space-x-2 z-10">
//           {backgroundImages.map((_, index) => (
//             <button
//               key={index}
//               onClick={() => setCurrentImageIndex(index)}
//               className={`w-3 h-3 rounded-full transition-all duration-300 ${
//                 index === currentImageIndex ? 'bg-white scale-110' : 'bg-white/50 scale-100'
//               }`}
//               aria-label={`Przejdź do slajdu ${index + 1}`}
//             />
//           ))}
//         </div>
//       )}
//     </section>
//   );
// };

// export default Hero;

import React, { useState, useEffect } from 'react';

const Hero = () => {
  const API_BASE = '/kolorowedomki/api';
  
  const [heroData, setHeroData] = useState({
    backgroundImages: [
      "/images/Hero1.jpg",         // POPRAWIONE: usunięto "kolorowedomki"
      "/images/Hero2.jpg", //WIONE: usunięto "kolorowedomki"
      "/images/Hero3.jpg",//POPRAWIONE: usunięto "kolorowedomki"
      "/images/Hero4.jpg",//POPRAWIONE: usunięto "kolorowedomki"
      "/images/Hero5.jpg",/// POPRAWIONE: usunięto "kolorowedomki"
    ],
    title: "Kolorowe Domki",
    subtitle: "Idealne miejsce nad morzem dla rodzin z dziećmi",
    titleStyle: {
      fontSize: "6xl",
      fontWeight: "extrabold",
      color: "#ffffff"
    },
    subtitleStyle: {
      fontSize: "2xl",
      fontWeight: "light",
      color: "#ffffff"
    },
    overlay: {
      enabled: true,
      gradient: "bg-gradient-to-br from-black/60 to-black/30"
    },
    slideshowInterval: 5000
  });

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Załaduj dane z serwera
  useEffect(() => {
    const fetchHeroData = async () => {
      try {
        setLoading(true);
        console.log('Pobieram dane hero z:', `${API_BASE}/hero.php`);
        
        const response = await fetch(`${API_BASE}/hero.php?t=${Date.now()}`);
        
        if (!response.ok) {
          throw new Error(`Błąd HTTP: ${response.status}`);
        }
        
        const data = await response.json();
        console.log('Otrzymane dane hero:', data);
        
        setHeroData(data);
        setError(null);
      } catch (error) {
        console.error('Błąd ładowania danych hero:', error);
        
        // Używamy domyślnych danych w przypadku błędu
      } finally {
        setLoading(false);
      }
    };

    fetchHeroData();

    // Sprawdzaj zmiany co 30 sekund
    const interval = setInterval(fetchHeroData, 30000);
    return () => clearInterval(interval);
  }, []);

  // Effect for handling the slideshow
  useEffect(() => {
    if (!heroData.backgroundImages || heroData.backgroundImages.length === 0) {
      return;
    }

    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => {
        return (prevIndex + 1) % heroData.backgroundImages.length;
      });
    }, heroData.slideshowInterval || 5000);

    return () => clearInterval(interval);
  }, [heroData.slideshowInterval, heroData.backgroundImages]);

  // Funkcja do bezpiecznego pobierania klas Tailwind
  const getTextSizeClass = (size) => {
    const sizeMap = {
      'xs': 'text-xs',
      'sm': 'text-sm',
      'base': 'text-base',
      'lg': 'text-lg',
      'xl': 'text-xl',
      '2xl': 'text-2xl',
      '3xl': 'text-3xl',
      '4xl': 'text-4xl',
      '5xl': 'text-5xl',
      '6xl': 'text-6xl',
      '7xl': 'text-7xl',
      '8xl': 'text-8xl'
    };
    return sizeMap[size] || 'text-6xl';
  };

  const getFontWeightClass = (weight) => {
    const weightMap = {
      'light': 'font-light',
      'normal': 'font-normal',
      'medium': 'font-medium',
      'semibold': 'font-semibold',
      'bold': 'font-bold',
      'extrabold': 'font-extrabold',
      'black': 'font-black'
    };
    return weightMap[weight] || 'font-bold';
  };

  if (loading) {
    return (
      <section className="h-screen flex items-center justify-center text-white relative overflow-hidden bg-gray-200">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
          <p className="text-gray-700">Ładowanie...</p>
        </div>
      </section>
    );
  }

  // Bezpieczne pobranie obrazków - jeśli brak, użyj domyślnych
  const backgroundImages = heroData.backgroundImages && heroData.backgroundImages.length > 0 
    ? heroData.backgroundImages 
    : ["/images/hero1.jpg"];

  // Funkcja do debugowania ścieżek obrazów
  const debugImages = () => {
    console.log('Aktualne ścieżki obrazów:', backgroundImages);
    backgroundImages.forEach((img, index) => {
      console.log(`Obraz ${index}: ${img}`);
    });
  };

  return (
    <section className="hero-section h-screen flex items-center justify-center text-white relative overflow-hidden">
      {/* Przycisk debugowania (tylko development) */}
      {process.env.NODE_ENV === 'development' && (
        <button 
          onClick={debugImages}
          className="absolute top-4 right-4 bg-blue-500 text-white px-3 py-1 rounded text-sm z-50"
          style={{zIndex: 1000}}
        >
          Debug Images
        </button>
      )}
      
      {/* Komunikat o błędzie */}
      {error && (
        <div className="absolute top-4 left-4 right-4 bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-3 rounded z-50">
          {error}
        </div>
      )}
      
      {/* Background images container */}
      <div className="hero-background absolute inset-0">
        {backgroundImages.map((image, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-1000 ${
              index === currentImageIndex ? 'opacity-100' : 'opacity-0'
            }`}
          >
            {/* Zdjęcie tła */}
            <div 
              className="absolute inset-0 bg-cover bg-center"
              style={{ 
                backgroundImage: `url('${image}')`,
                backgroundPosition: 'center',
                backgroundSize: 'cover'
              }}
            />
            
            {/* Overlay */}
            {heroData.overlay?.enabled && (
              <div className={`absolute inset-0 ${heroData.overlay.gradient || 'bg-gradient-to-br from-black/60 to-black/30'}`} />
            )}
          </div>
        ))}
      </div>
      
      {/* Text Container */}
      <div className="relative z-10 text-center px-4 max-w-4xl mx-auto">
        <h1 
          className={`${getTextSizeClass(heroData.titleStyle?.fontSize)} ${getFontWeightClass(heroData.titleStyle?.fontWeight)} mb-4 drop-shadow-2xl`}
          style={{ color: heroData.titleStyle?.color || '#ffffff' }}
        >
          {heroData.title || "Kolorowe Domki"}
        </h1>
        <p 
          className={`${getTextSizeClass(heroData.subtitleStyle?.fontSize)} ${getFontWeightClass(heroData.subtitleStyle?.fontWeight)} drop-shadow-2xl`}
          style={{ color: heroData.subtitleStyle?.color || '#ffffff' }}
        >
          {heroData.subtitle || "Idealne miejsce nad morzem dla rodzin z dziećmi"}
        </p>
      </div>
      
      {/* Navigation dots */}
      {backgroundImages.length > 1 && (
        <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex space-x-2 z-10">
          {backgroundImages.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentImageIndex(index)}
              className={`w-3 h-3 rounded-full transition-all duration-300 ${
                index === currentImageIndex ? 'bg-white scale-110' : 'bg-white/50 scale-100'
              }`}
              aria-label={`Przejdź do slajdu ${index + 1}`}
            />
          ))}
        </div>
      )}
    </section>
  );
};

export default Hero;